module.exports = __webpack_public_path__ + "static/media/ser-5.04bb5291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ser-5.png
// module id = 206
// module chunks = 0